var _style, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.5 16.5",
    style: {
      enableBackground: "new 0 0 16.5 16.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4BA84F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.3,3.4c-0.4-1.8-1.5-2.9-3.2-3.3c-1.4-0.2-2.9-0.2-4.3,0C7.8,0.4,7,0.8,6.4,1.3C5.6,2.2,5.2,3.2,5.1,4.8 c0,0.3,0.1,0.4,0.2,0.4c0.2,0.1,0.3,0.1,0.4,0.1c0.3,0,0.6-0.2,0.7-0.6V4.3c0-0.1,0-0.2,0.1-0.4V3.8c0.2-1.3,1-2.1,2.2-2.4 c1.4-0.3,2.6-0.3,4,0c1.2,0.3,1.9,1,2.2,2.2c0.1,0.5,0.2,1.1,0.2,1.8V11c0,0.6-0.1,1.2-0.2,1.6c-0.3,1.3-1.1,2-2.3,2.3 c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0-0.4,0.1-0.6,0.1h-0.9c-0.7,0-1.2-0.1-1.8-0.2c-1.2-0.3-1.9-1-2.2-2.1c0-0.2,0-0.4-0.1-0.6 c0-0.2,0-0.3,0-0.5v-0.1c0-0.4-0.3-0.7-0.6-0.7H5.7c-0.1,0-0.2,0-0.3,0.1H5.3l-0.1,0.1C5,11.3,5,11.5,5,11.6c0,0.2,0,0.3,0.1,0.5 c0,0.1,0,0.3,0.1,0.5c0.4,1.8,1.4,2.9,3,3.3c0.8,0.4,1.6,0.5,2.5,0.5c0.8,0,1.6-0.1,2.5-0.3c1.6-0.4,2.6-1.4,3-3 c0.2-0.8,0.3-1.4,0.3-2.2V5.4C16.5,4.8,16.4,4,16.3,3.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.7,10.4L2.9,9.6C2.6,9.3,2.4,9.1,2.3,8.9h8.3c0.3,0,0.6-0.3,0.6-0.6c0-0.4-0.2-0.7-0.5-0.7H2.3l0.3-0.3 c0.3-0.4,0.5-0.7,0.8-0.9L3.8,6C3.9,5.9,4,5.8,4,5.6S3.9,5.3,3.8,5.1C3.7,5,3.5,4.9,3.3,4.9l0,0C3.2,4.9,3,5,2.9,5.1 C2.4,5.6,1.9,6,1.5,6.5C1,6.9,0.6,7.3,0.2,7.7L0.1,7.8C0,8.1,0,8.4,0.1,8.7l2.6,2.7c0.2,0.2,0.4,0.2,0.5,0.2h0.1 c0.2,0,0.5-0.1,0.5-0.4c0.1-0.2,0.1-0.3,0-0.5C3.9,10.6,3.8,10.5,3.7,10.4z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon-exit.995c58c7dcc05e422f6fc96e6b7aeef1.svg";
export { ForwardRef as ReactComponent };